import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';
import { StaticsServices } from '../../../services/statics';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-rest-web-edit-carta',
  templateUrl: 'configuration-rest-web-edit-carta.html',
})
export class ConfigurationRestWebEditCartaPage {

  public form: FormGroup;
  public firestore: any;
  carta: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public staticsServices: StaticsServices) {
    this.carta = this.navParams.get('carta');
    this.firestore = firebase.firestore();
  }


  activateInTk(element) {
    element.tk_active = true;
  }

  desactivateOfTk(element) {
    element.tk_active = false;
  }

  activateFeatured(element) {
    element.featured = true;
  }

  desactivateFeatured(element) {
    element.featured = false;
  }

  updatePrices() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: 'Guardando...'
    });
    loadingPopup.present();
    var list_elements = [];
    //preparamos listado con precios actualizados (caso 2 elementos pilla el ultimo precio)
    for (let i in this.carta.pages) {
      for (let x in this.carta.pages[i].sections) {
        for (let z in this.carta.pages[i].sections[x].elements) {
          var index = list_elements.findIndex(item => item.uid == this.carta.pages[i].sections[x].elements[z].uid);
          if (index >= 0) {
            list_elements[index].price_takeaway = this.carta.pages[i].sections[x].elements[z].price_takeaway;
          } else {
            list_elements.push(this.carta.pages[i].sections[x].elements[z]);
          }
        }
      }
    }
    //actualizamos elementos individualmente
    for (let element of list_elements) {
      if (element.featured == undefined) {
        element.featured = false;
      }
      if (element.tk_active == undefined) {
        element.tk_active = true;
      }
      if (element.price_takeaway == undefined) {
        element.price_takeaway = 0;
      }
      if (element.type == 'dish') {//dishes
        this.configurationServices.afs.collection('dish').doc(element.uid).update({
          'price_takeaway': element.price_takeaway,
          'tk_active': element.tk_active,
          'featured': element.featured
        });
      } else if (element.type == 'product') {//products
        this.configurationServices.afs.collection('products').doc(element.uid).update({
          'pvp_takeaway': element.price_takeaway,
          'tk_active': element.tk_active,
          'featured': element.featured
        });
      } else {//combo
        this.configurationServices.afs.collection('menus').doc(element.uid).update({
          'price_takeaway': element.price_takeaway,
          'tk_active': element.tk_active,
          'featured': element.featured
        });
      }
    }
    //update all carta data
    var cloned_carta = Object.assign({}, this.carta);
    delete cloned_carta.UID;
    this.configurationServices.afs.collection('cartas').doc(this.carta.UID).update(cloned_carta);
    //statics
    this.staticsServices.changeStateStaticWait(true);
    loadingPopup.dismiss();
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rest-web/configuration-rest-web-edit-carta/configuration-rest-web-edit-carta.ts